// --- Store configuration and utilities ---
const StoreConfig = {
  UK_STORE_DOMAIN: 'metamarkuk.myshopify.com',
  NON_TRANS_STORE_DOMAIN: 'metamark-non-trans-prod.myshopify.com',
  AU_STORE_DOMAIN: 'www.metamark.au',
  CA_STORE_DOMAIN: 'www.metamark-canada.ca',
  ASIA_STORE_DOMAIN: 'www.metamark.asia',
  EU_STORE_DOMAIN: 'www.metamark.eu',

  UK_COUNTRY_CODES: ['GB', 'UK'],
  ASIA_COUNTRY_CODES: [
    'AF', 'AM', 'AZ', 'BH', 'BD', 'BT', 'BN', 'KH', 'CN', 'CY', 'GE', 'HK', 'IN', 'ID', 'IQ', 'IL', 'JP', 'JO', 'KZ', 'KW', 'KG', 'LA', 'LB', 'MO', 'MY', 'MV', 'MN', 'MM', 'NP', 'OM', 'PK', 'PS', 'PH', 'QA', 'SA', 'SG', 'KR', 'LK', 'TW', 'TJ', 'TH', 'TL', 'TR', 'TM', 'AE', 'UZ', 'VN', 'YE'
  ],
  EUROPE_COUNTRY_CODES: [
    'DK', 'EE', 'FI', 'IS', 'LV', 'LT', 'NO', 'SE', 'AL', 'AD', 'BA', 'HR', 'GR', 'IT', 'MT', 'ME', 'PT', 'SM', 'RS', 'SI', 'ES', 'VA', 'MK', 'BY', 'BG', 'CZ', 'HU', 'MD', 'PL', 'RO', 'SK', 'UA', 'AT', 'BE', 'FR', 'DE', 'IE', 'LI', 'LU', 'MC', 'NL', 'CH'
  ],

  // Get full store URL based on domain
  getStoreURL: function (domain) {
    return `https://${domain}`;
  },

  // Check if a country code is for UK
  isUKCountry: function (countryCode) {
    return this.UK_COUNTRY_CODES.includes(countryCode.toUpperCase());
  },

  // Check if a country code is for Asia
  isAsiaCountry: function (countryCode) {
    return this.ASIA_COUNTRY_CODES.includes(countryCode.toUpperCase());
  },

  // Check if a country code is for Europe (excluding UK)
  isEuropeCountry: function (countryCode) {
    return this.EUROPE_COUNTRY_CODES.includes(countryCode.toUpperCase());
  },

  // Check if current hostname is UK store
  isUKStore: function () {
    return (
      window.location.hostname === this.UK_STORE_DOMAIN ||
      window.location.hostname === 'metamark.co.uk'
    );
  },

  // Check if current hostname is non-transactional store
  isNonTransStore: function () {
    return window.location.hostname.includes(this.NON_TRANS_STORE_DOMAIN);
  },

  // Check if current hostname is Australia store
  isAUStore: function () {
    return window.location.hostname === this.AU_STORE_DOMAIN;
  },

  // Check if current hostname is Canada store
  isCAStore: function () {
    return window.location.hostname === this.CA_STORE_DOMAIN;
  },

  // Check if current hostname is Asia store
  isAsiaStore: function () {
    return window.location.hostname === this.ASIA_STORE_DOMAIN;
  },

  // Check if current hostname is Europe store
  isEUStore: function () {
    return window.location.hostname === this.EU_STORE_DOMAIN;
  },
};

// --- Multi-store redirect logic ---
function handleCountryRedirect(countryCode) {
  if (!countryCode) {
    console.error('No country code provided for redirect');
    return;
  }

  const code = countryCode.toUpperCase();
  const isUK = StoreConfig.isUKCountry(code);
  const isAsia = StoreConfig.isAsiaCountry(code);
  const isEurope = StoreConfig.isEuropeCountry(code);

  if (isUK) {
    window.location.href = `${StoreConfig.getStoreURL(
      StoreConfig.UK_STORE_DOMAIN
    )}${window.location.pathname}`;
  } else if (code === 'AU') {
    window.location.href = `${StoreConfig.getStoreURL(
      StoreConfig.AU_STORE_DOMAIN
    )}${window.location.pathname}${window.location.search ? window.location.search + '&' : '?'}country=${code}`;
  } else if (code === 'CA') {
    window.location.href = `${StoreConfig.getStoreURL(
      StoreConfig.CA_STORE_DOMAIN
    )}${window.location.pathname}${window.location.search ? window.location.search + '&' : '?'}country=${code}`;
  } else if (isAsia) {
    window.location.href = `${StoreConfig.getStoreURL(
      StoreConfig.ASIA_STORE_DOMAIN
    )}${window.location.pathname}${window.location.search ? window.location.search + '&' : '?'}country=${code}`;
  } else if (isEurope) {
    window.location.href = `${StoreConfig.getStoreURL(
      StoreConfig.EU_STORE_DOMAIN
    )}${window.location.pathname}${window.location.search ? window.location.search + '&' : '?'}country=${code}`;
  } else {
    window.location.href = `${StoreConfig.getStoreURL(
      StoreConfig.NON_TRANS_STORE_DOMAIN
    )}${window.location.pathname}${window.location.search ? window.location.search + '&' : '?'}country=${code}`;
  }
}

// Multi-country switcher module
const CountrySwitcher = (function () {
  // DOM elements cache
  const elements = {};

  // Configuration
  const config = {
    countriesWithThe: [
      'Bahamas',
      'Gambia',
      'Netherlands',
      'Philippines',
      'United Kingdom',
      'United States',
      'Maldives',
      'Seychelles',
      'Comoros',
      'Dominican Republic',
      'Czech Republic',
      'Central African Republic',
      'Marshall Islands',
      'Solomon Islands',
      'Federated States of Micronesia',
    ],
    isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    ) && window.innerWidth <= 768,
  };

  // State management
  const state = {
    isDropdownOpen: false,
    triggeredByDisclosureButton: false,
    countrySelectInitialized: false
  };

  /**
   * Initialize the module
   */
  function init() {
    cacheElements();
    bindEvents();
    fetchGeoData();
    setupSelectBox();

    // Set a retry for elements that might not be immediately available
    setTimeout(function () {
      if (!state.countrySelectInitialized) {
        cacheElements();
        setupSelectBox();
        changeSelectboxState();
      }
    }, 1000);
  }

  /**
   * Cache DOM elements to avoid repetitive queries
   */
  function cacheElements() {
    elements.modal = document.getElementById('currency-switcher-pop');
    elements.mobileModal = document.getElementById(
      'Details-menu-drawer-container'
    );
    elements.closeBtn = document.querySelectorAll('.close');
    elements.changeCountryBtn = document.getElementById('changeCountryBtn');
    elements.backBtn = document.getElementById('backBtn');
    elements.continueBtn = document.getElementById('continueBtn');
    elements.continueStoreBtn = document.getElementById('continueStoreBtn');
    elements.screen1 = document.getElementById('screen1');
    elements.screen2 = document.getElementById('screen2');
    elements.countryWrapper = document.querySelector(
      '[data-geo-country-wrapper]'
    );

    // Try different ways to find the country select
    elements.selectBox = document.getElementById('country-select');
    if (!elements.selectBox) {
      elements.selectBox = document.querySelector('select[name="country_code"]');
    }

    if (elements.selectBox) {
      state.countrySelectInitialized = true;
    }

    elements.floatingLabel = document.getElementById('floatingLabel');
    elements.disclosureButtons = document.querySelectorAll(
      '.disclosure__button'
    );
    elements.headerFooterCountrySpans = document.querySelectorAll(
      '.localization-option-inverse-color'
    );
  }

  /**
   * Bind all event listeners
   */
  function bindEvents() {
    if (elements.disclosureButtons) {
      elements.disclosureButtons.forEach((button) => {
        button.addEventListener('click', handleDisclosureButtonClick);
      });
    }

    if (elements.closeBtn) {
      elements.closeBtn.forEach((button) => {
        button.addEventListener('click', function () {
          closeModal();
          // Also close market switcher if it's open
          if (window.toggleMarketSwitcher) {
            const container = document.getElementById('market-switcher-container');
            if (container && !container.classList.contains('hidden')) {
              window.toggleMarketSwitcher();
            }
          }
        });
      });
    }

    if (elements.continueStoreBtn) {
      elements.continueStoreBtn.addEventListener(
        'click',
        handleContinueStoreBtn
      );
    }

    if (elements.changeCountryBtn) {
      elements.changeCountryBtn.addEventListener('click', showScreen2);
    }

    if (elements.backBtn) {
      elements.backBtn.addEventListener('click', handleBackButton);
    }

    if (elements.continueBtn) {
      elements.continueBtn.addEventListener('click', handleContinueButton);
    }

    window.addEventListener('click', handleOutsideClick);

    if (elements.modal) {
      elements.modal.addEventListener('click', handleModalInteraction);
      elements.modal.addEventListener('mouseover', handleModalInteraction);
    }

    changeSelectboxState();
  }

  function handleContinueStoreBtn(event) {
    event.preventDefault();

    let countrySelect = document.getElementById('country-select');
    if (!countrySelect) {
      countrySelect = document.querySelector('select[name="country_code"]');
    }

    if (countrySelect && countrySelect.value) {
      const selectedCountry = countrySelect.value.toUpperCase();
      const isUKSelected = StoreConfig.isUKCountry(selectedCountry);
      const isAsiaSelected = StoreConfig.isAsiaCountry(selectedCountry);
      const isEuropeSelected = StoreConfig.isEuropeCountry(selectedCountry);
      const isNonTransStore = StoreConfig.isNonTransStore();
      const isAUStore = StoreConfig.isAUStore();
      const isCAStore = StoreConfig.isCAStore();
      const isAsiaStore = StoreConfig.isAsiaStore();
      const isEUStore = StoreConfig.isEUStore();

      if (isNonTransStore) {
        if (
          isUKSelected ||
          selectedCountry === 'AU' ||
          selectedCountry === 'CA' ||
          isAsiaSelected ||
          isEuropeSelected
        ) {
          handleCountryRedirect(selectedCountry);
        } else {
          closeModal();
        }
      } else if (isAUStore) {
        if (selectedCountry === 'AU') {
          closeModal();
        } else {
          handleCountryRedirect(selectedCountry);
        }
      } else if (isCAStore) {
        if (selectedCountry === 'CA') {
          closeModal();
        } else {
          handleCountryRedirect(selectedCountry);
        }
      } else if (isEUStore) {
        // Get current store country code (e.g., 'FR' for France)
        const currentStoreCountry = window.storeCountry && window.storeCountry.code ? window.storeCountry.code.toUpperCase() : null;
        if (isEuropeSelected && selectedCountry === currentStoreCountry) {
          closeModal();
        } else {
          handleCountryRedirect(selectedCountry);
        }
      } else if (isAsiaStore) {
        const currentStoreCountry = window.storeCountry && window.storeCountry.code ? window.storeCountry.code.toUpperCase() : null;
        if (isAsiaSelected && selectedCountry === currentStoreCountry) {
          closeModal();
        } else {
          handleCountryRedirect(selectedCountry);
        }
      } else {
        if (isUKSelected) {
          //closeModal();
          handleCountryRedirect(selectedCountry);
        } else {
          handleCountryRedirect(selectedCountry);
        }
      }
    } else {
      closeModal();
    }
  }

  function changeSelectboxState() {
    let selectBox = document.getElementById('country-select');
    if (!selectBox) {
      selectBox = document.querySelector('select[name="country_code"]');
    }

    if (!selectBox) {
      return;
    }

    const isTransactionalStore = StoreConfig.isUKStore();
    const isAUStore = StoreConfig.isAUStore();
    const isCAStore = StoreConfig.isCAStore();
    const isAsiaStore = StoreConfig.isAsiaStore();
    const isEUStore = StoreConfig.isEUStore();

    if (window.storeCountry && window.storeCountry.code) {
      const code = window.storeCountry.code.toUpperCase();
      if (code !== 'GB' && isTransactionalStore) {
        updateSelectAndSpans(selectBox, 'GB', 'United Kingdom');
      } else if (code !== 'AU' && isAUStore) {
        updateSelectAndSpans(selectBox, 'AU', 'Australia');
      } else if (code !== 'CA' && isCAStore) {
        updateSelectAndSpans(selectBox, 'CA', 'Canada');
      } else if (isAsiaStore && !StoreConfig.isAsiaCountry(code)) {
        updateSelectAndSpans(selectBox, 'SG', 'Singapore');
      } else if (isEUStore && !StoreConfig.isEuropeCountry(code)) {
        updateSelectAndSpans(selectBox, 'FR', 'France');
      }
    }
  }

  function updateSelectAndSpans(selectBox, value, text) {
    selectBox.querySelectorAll('option').forEach((option) => {
      option.selected = option.value.toUpperCase() === value;
    });

    if (elements.headerFooterCountrySpans) {
      elements.headerFooterCountrySpans.forEach((span) => {
        span.innerText = text;
      });
    }
  }

  function handleDisclosureButtonClick() {
    state.triggeredByDisclosureButton = true;
    elements.modal.style.display = 'block';
    elements.screen1.style.display = 'none';
    elements.screen2.style.display = 'block';
    document.body.classList.add('overflow-hidden');

    if (config.isMobile) {
      elements.modal.style.display = 'block';
    }
  }

  function closeModal() {
    elements.modal.style.display = 'none';
    document.body.classList.remove('overflow-hidden');
    localStorage.setItem('popupshown', true);
    state.triggeredByDisclosureButton = false;

    // Also close market switcher if it's open
    if (window.toggleMarketSwitcher) {
      const container = document.getElementById('market-switcher-container');
      if (container && !container.classList.contains('hidden')) {
        window.toggleMarketSwitcher();
      }
    }
  }

  function handleOutsideClick(event) {
    if (event.target === elements.modal) {
      elements.modal.style.display = 'none';
      document.body.classList.remove('overflow-hidden');
    }
  }

  function showScreen2() {
    elements.screen1.style.display = 'none';
    elements.screen2.style.display = 'block';
  }

  function handleBackButton(event) {
    event.preventDefault();

    if (state.triggeredByDisclosureButton) {
      elements.modal.style.display = 'none';
      document.body.classList.remove('overflow-hidden');
      state.triggeredByDisclosureButton = false;
    } else {
      elements.screen2.style.display = 'none';
      elements.screen1.style.display = 'block';
    }
  }

  function removeCountryQueryParam() {
    const url = new URL(window.location.href);
    url.searchParams.delete('country');
    window.history.replaceState({}, document.title, url.pathname + url.search);
  }

  function handleContinueButton(event) {
    if (!event) event = window.event;
    if (event) event.preventDefault();

    localStorage.setItem('popupshown', true);

    let countrySelect = document.getElementById('country-select');
    if (!countrySelect) {
      countrySelect = document.querySelector('select[name="country_code"]');
    }

    if (!countrySelect || !countrySelect.value) {
      closeModal();
      return;
    }

    const selectedCountry = countrySelect.value.toUpperCase();
    const isUKSelected = StoreConfig.isUKCountry(selectedCountry);
    const isAsiaSelected = StoreConfig.isAsiaCountry(selectedCountry);
    const isEuropeSelected = StoreConfig.isEuropeCountry(selectedCountry);
    const isNonTransStore = StoreConfig.isNonTransStore();
    const isAUStore = StoreConfig.isAUStore();
    const isCAStore = StoreConfig.isCAStore();
    const isAsiaStore = StoreConfig.isAsiaStore();
    const isEUStore = StoreConfig.isEUStore();

    const form = event && event.currentTarget ? event.currentTarget.closest('form') : null;

    if (isNonTransStore) {
      if (
        isUKSelected ||
        selectedCountry === 'AU' ||
        selectedCountry === 'CA' ||
        isAsiaSelected ||
        isEuropeSelected
      ) {
        handleCountryRedirect(selectedCountry);
      } else {
        removeCountryQueryParam();
        if (form) {
          form.submit();
        } else {
          closeModal();
        }
      }
    } else if (isAUStore) {
      if (selectedCountry === 'AU') {
        closeModal();
      } else {
        handleCountryRedirect(selectedCountry);
      }
    } else if (isCAStore) {
      if (selectedCountry === 'CA') {
        closeModal();
      } else {
        handleCountryRedirect(selectedCountry);
      }
    } else if (isAsiaStore) {
      const currentStoreCountry = window.storeCountry && window.storeCountry.code ? window.storeCountry.code.toUpperCase() : null;
      if (isAsiaSelected && selectedCountry === currentStoreCountry) {
        closeModal();
      } else {
        handleCountryRedirect(selectedCountry);
      }
    } else if (isEUStore) {
      const currentStoreCountry = window.storeCountry && window.storeCountry.code ? window.storeCountry.code.toUpperCase() : null;
      if (isEuropeSelected && selectedCountry === currentStoreCountry) {
        closeModal();
      } else {
        handleCountryRedirect(selectedCountry);
      }
    } else {
      if (isUKSelected) {
        closeModal();
      } else {
        handleCountryRedirect(selectedCountry);
      }
    }
  }

  function handleModalInteraction() {
    if (
      state.triggeredByDisclosureButton &&
      config.isMobile &&
      elements.mobileModal
    ) {
      elements.mobileModal.setAttribute('open', '');
    }
  }

  function fetchGeoData() {
    fetch(window.Shopify.routes.root + 'browsing_context_suggestions.json')
      .then((res) => res.json())
      .then((data) => {
        if (data && data.detected_values && data.detected_values.country) {
          handleCountryData(data.detected_values.country);
        }
      })
      .catch((error) => console.error('Error fetching geo data:', error));
  }

  function handleCountryData(countryData) {
    const formattedCountry = formatCountryName(countryData.name);
    const countryCode = countryData.handle.toUpperCase();

    if (elements.countryWrapper) {
      elements.countryWrapper.innerHTML = elements.countryWrapper.innerHTML.replace(
        '{{ country_name }}',
        formattedCountry
      );

      const isUKCountry = StoreConfig.isUKCountry(countryCode);
      const isUKStore = StoreConfig.isUKStore();
      const isNonTransStore = StoreConfig.isNonTransStore();
      const isAUStore = StoreConfig.isAUStore();
      const isCAStore = StoreConfig.isCAStore();
      const isAsiaStore = StoreConfig.isAsiaStore();
      const isEUStore = StoreConfig.isEUStore();
      const isAsiaCountry = StoreConfig.isAsiaCountry(countryCode);
      const isEuropeCountry = StoreConfig.isEuropeCountry(countryCode);

      const shouldHidePopup =
        (isUKCountry && isUKStore) ||
        (countryCode === 'AU' && isAUStore) ||
        (countryCode === 'CA' && isCAStore) ||
        (isAsiaCountry && isAsiaStore) ||
        (isEuropeCountry && isEUStore) ||
        localStorage.getItem('popupshown') ||
        countryCode === 'US';

      if (!shouldHidePopup) {
        setTimeout(() => {
          elements.modal.style.display = 'block';
          document.body.classList.add('overflow-hidden');
        }, 1000);
      }
    }
  }

  function formatCountryName(countryName) {
    return config.countriesWithThe.includes(countryName) ?
      `the ${countryName}` :
      countryName;
  }

  function setupSelectBox() {
    let selectBox = document.getElementById('country-select');
    if (!selectBox) {
      selectBox = document.querySelector('select[name="country_code"]');
    }

    if (selectBox && elements.floatingLabel) {
      selectBox.addEventListener('mousedown', showFloatingLabel);
      selectBox.addEventListener('focus', showFloatingLabel);
      selectBox.addEventListener('click', toggleFloatingLabel);
      selectBox.addEventListener('blur', hideFloatingLabel);

      elements.selectBox = selectBox;
      state.countrySelectInitialized = true;
    }
  }

  function showFloatingLabel() {
    if (elements.floatingLabel) {
      elements.floatingLabel.classList.remove('hidden');
    }
  }

  function toggleFloatingLabel() {
    state.isDropdownOpen = !state.isDropdownOpen;

    if (elements.floatingLabel) {
      if (state.isDropdownOpen) {
        elements.floatingLabel.classList.remove('hidden');
      } else {
        elements.floatingLabel.classList.add('hidden');
      }
    }
  }

  function hideFloatingLabel() {
    state.isDropdownOpen = false;

    if (elements.floatingLabel) {
      elements.floatingLabel.classList.add('hidden');
    }
  }

  // Public API
  return {
    init,
  };
})();

// Initialize the module when the DOM is fully loaded
document.addEventListener('DOMContentLoaded', CountrySwitcher.init);